import React, { Component, type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import InlineDialog from '@atlaskit/inline-dialog';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import type { ClosedSprint } from '@atlassian/jira-shared-types';

type Props = {
	shouldHideLinks: boolean;
	closedSprints: ClosedSprint[];
	closedSprintsLabel: string | null;
};

type State = {
	isDialogOpen: boolean;
};

// eslint-disable-next-line jira/react/no-class-components
export default class ClosedSprintsView extends Component<Props, State> {
	static defaultProps = {
		shouldHideLinks: false,
		closedSprints: [],
		closedSprintsLabel: null,
	};

	state = {
		isDialogOpen: false,
	};

	handleButtonClick = (e: SyntheticEvent<HTMLElement>) => {
		this.setState({
			isDialogOpen: !this.state.isDialogOpen,
		});
		e.stopPropagation();
	};

	handleDialogClose = (data: { isOpen: false; event: SyntheticEvent<HTMLDivElement> }) => {
		this.setState({
			isDialogOpen: data.isOpen,
		});
	};

	handleDialogClick = (e: SyntheticEvent<HTMLDivElement>) => {
		e.stopPropagation();
	};

	handleDialogMouseDown = (e: SyntheticEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
	};

	renderInlineDialogContent = () => (
		<div>
			<Title>{this.props.closedSprintsLabel}</Title>
			{this.props.closedSprints.map((sprint) => (
				<ItemContainer key={sprint.name}>
					{this.props.shouldHideLinks ? (
						<NameSpan>{sprint.name}</NameSpan>
					) : (
						<NameLink href={sprint.href}>{sprint.name}</NameLink>
					)}
					<NoWrapDate>{sprint.endDate}</NoWrapDate>
				</ItemContainer>
			))}
		</div>
	);

	render() {
		return (
			<Container onClick={this.handleDialogClick} onMouseDown={this.handleDialogMouseDown}>
				<InlineDialog
					content={this.renderInlineDialogContent()}
					isOpen={this.state.isDialogOpen}
					// @ts-expect-error - TS2322 - Type '(data: {    isOpen: false;    event: SyntheticEvent<HTMLDivElement>;}) => void' is not assignable to type '(obj: { isOpen: boolean; event: Event; }) => void'.
					onClose={this.handleDialogClose}
					placement="bottom"
				>
					<Button
						onClick={this.handleButtonClick}
						spacing="none"
						isSelected={this.state.isDialogOpen}
						interactionName="auto-generated.jira-issue-internal-fields.sprint.closed-sprints.button"
					>
						<ClosedSprintsCount>{`+${this.props.closedSprints.length}`}</ClosedSprintsCount>
					</Button>
				</InlineDialog>
			</Container>
		);
	}
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	marginLeft: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ClosedSprintsCount = styled.span({
	padding: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ItemContainer = styled.div({
	marginTop: token('space.100', '8px'),
	display: 'flex',
	justifyContent: 'space-between',
	maxWidth: '300px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Title = styled.span({
	fontWeight: 500,
});

const nameStyles = `
    margin-right: ${gridSize * 3}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const NameLink = styled.a(nameStyles);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const NameSpan = styled.span(nameStyles);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const NoWrapDate = styled.div({
	whiteSpace: 'nowrap',
});
